export default __webpack_public_path__ + "static/media/Weather_Journal_App.3b57fab0.PNG";